import config from 'react-global-configuration';

import {
  setOperationStatus,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  UI_OPERATION_STATUS_REASON_UNKNOWN,
  UI_OPERATION_STATUS_ERROR,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../config/constants';
import { Thunk } from '../../../types';

export const buddyInviteAccept = (pairingCode: string): Thunk => (
  (dispatch, getState) => {
    const apiUrl = config.get('API_URL') as string;
    const language = getState().getIn(['ui', 'language'], DEFAULT_LANGUAGE);
    const multilingual = config.get('MULTILINGUAL', true) as boolean;
    const path = multilingual ? `${apiUrl}/${language}` : apiUrl;

    dispatch(setOperationStatus('buddy', 'accept', UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_REASON_UNKNOWN));

    fetch(`${path}/buddy/invite/accept`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        pairing_code: pairingCode,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.statusText);
      })
      .then(() => {
        dispatch(setOperationStatus('buddy', 'accept', UI_OPERATION_STATUS_SUCCESS, UI_OPERATION_STATUS_REASON_UNKNOWN));
      }).catch((error) => {
        dispatch(setOperationStatus('buddy', 'accept', UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REASON_UNKNOWN));
        console.error(error);
      });
  }
);

export const buddyInviteRefuse = (pairingCode: string, refusalReason: string): Thunk => (
  (dispatch, getState) => {
    const apiUrl = config.get('API_URL') as string;
    const language = getState().getIn(['ui', 'language'], DEFAULT_LANGUAGE);
    const multilingual = config.get('MULTILINGUAL', true) as boolean;
    const path = multilingual ? `${apiUrl}/${language}` : apiUrl;

    dispatch(setOperationStatus('buddy', 'refuse', UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_REASON_UNKNOWN));

    fetch(`${path}/buddy/invite/refuse`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        pairing_code: pairingCode,
        refusal_reason: refusalReason,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.statusText);
      })
      .then(() => {
        dispatch(setOperationStatus('buddy', 'refuse', UI_OPERATION_STATUS_SUCCESS, UI_OPERATION_STATUS_REASON_UNKNOWN));
      }).catch((error) => {
        dispatch(setOperationStatus('buddy', 'refuse', UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REASON_UNKNOWN));
        console.error(error);
      });
  }
);

export const buddyUnsubscribe = (pairingCode: string): Thunk => (
  (dispatch, getState) => {
    const apiUrl = config.get('API_URL') as string;
    const language = getState().getIn(['ui', 'language'], DEFAULT_LANGUAGE);
    const multilingual = config.get('MULTILINGUAL', true) as boolean;
    const path = multilingual ? `${apiUrl}/${language}` : apiUrl;

    dispatch(setOperationStatus('buddy', 'unsubscribe', UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_REASON_UNKNOWN));

    fetch(`${path}/buddy/unsubscribe`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        pairing_code: pairingCode,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.statusText);
      })
      .then(() => {
        dispatch(setOperationStatus('buddy', 'unsubscribe', UI_OPERATION_STATUS_SUCCESS, UI_OPERATION_STATUS_REASON_UNKNOWN));
      }).catch((error) => {
        dispatch(setOperationStatus('buddy', 'unsubscribe', UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REASON_UNKNOWN));
        console.error(error);
      });
  }
);
